import React from 'react'
import { InfoBoxWrapper, InfoList, InfoWrapperIconWithText } from './styled'
import Text from '../../Text'
import { PaymentTexts } from '../../../texts/PaymentTexts'
import Icon from '../../Icon'
import NemKontoIcon from './../../../images/icons/nemkonto_logo.svg'
import InfoIcon from '../../../images/icons/info_new.svg'
import { PRODUCT_NAME } from '../../../config/main'

const InfoPayment = ({ theme, type = 'description', product = '' }) => {
    const getDetailLink = () =>
        product === PRODUCT_NAME.casinogo
            ? PaymentTexts.readMoreLinkGo
            : PaymentTexts.readMoreLink

    return (
        <InfoBoxWrapper type={type} theme={theme} margin={'32px 0 0'}>
            <InfoWrapperIconWithText>
                <Icon
                    color={theme.colors.colorIconInfoDefault}
                    height={'18px'}
                    width={'18px'}
                    src={InfoIcon}
                />
                <Text
                    size={13}
                    lineHeight={'20px'}
                    weight
                    margin={'0 0 0 8px'}
                    color={theme.colors.colorTextPrimaryDefault}
                >
                    {PaymentTexts.paymentInformation.title}
                </Text>
            </InfoWrapperIconWithText>
            <InfoList>
                <li>
                    {PaymentTexts.paymentInformation.minAmount}{' '}
                    <b className={'pl-5'}>
                        {PaymentTexts.paymentInformation.minAmountValue}
                    </b>
                </li>
                <li>
                    {PaymentTexts.paymentInformation.fee}{' '}
                    <b className={'pl-5'}>
                        {PaymentTexts.paymentInformation.feeValue}
                    </b>
                </li>
                <li>
                    {PaymentTexts.paymentInformation.processingTime}{' '}
                    <b className={'pl-5'}>
                        {PaymentTexts.paymentInformation.processingTimeValue}
                        <a
                            href={getDetailLink()}
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                            className={'pl-5'}
                        >
                            {PaymentTexts.readMore}
                        </a>
                    </b>
                </li>
                <li>
                    {PaymentTexts.paymentInformation.paymentMethods}{' '}
                    <Icon
                        src={NemKontoIcon}
                        width={'88px'}
                        height={'13px'}
                        color={theme.colors.colorIconPrimaryDefault}
                    />
                    <b className={'pl-5'}>
                        <a
                            href={getDetailLink()}
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                        >
                            {PaymentTexts.readMore}
                        </a>
                    </b>
                </li>
            </InfoList>
        </InfoBoxWrapper>
    )
}

export default InfoPayment
